/* eslint-disable */
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  addLocation: {
    id: 'locations.addLocation',
    description: 'Create new location',
    defaultMessage: 'Create new location',
  },
  editLocation: {
    id: 'locations.editLocation',
    description: 'Edit location',
    defaultMessage: 'Edit location',
  },
  mainInfo: {
    id: 'locations.mainInfo',
    description: 'Main Information Label',
    defaultMessage: 'Main Information',
  },
  addressDetails: {
    id: 'locations.addressDetails',
    description: 'Address details label',
    defaultMessage: 'Address Details',
  },
  defaultValues: {
    id: 'locations.defaultValues',
    description: 'Default Values Label',
    defaultMessage: 'Default Values',
  },
  location: {
    id: 'locations.location',
    description: 'Location',
    defaultMessage: 'Location',
  },
  backToLocationstBtn: {
    id: 'locations.backToLocationstBtn',
    description: 'Back To Locations',
    defaultMessage: 'Back To Locations',
  },
  sendCoordinates: {
    id: 'locations.sendCoordinates',
    description: 'Send Coordinates',
    defaultMessage: 'Send Coordinates',
  },
  deletePolygon: {
    id: 'locations.deletePolygon',
    description: 'Delete Selected Zone',
    defaultMessage: 'Delete Selected Zone',
  },
  deleteMarker: {
    id: 'locations.deleteMarker',
    description: 'Delete Marker',
    defaultMessage: 'Delete Marker',
  },
  transportMode: {
    id: 'locations.transportMode',
    description: 'Default Transport Mode',
    defaultMessage: 'Default Transport Mode',
  },
  country: {
    id: 'locations.country',
    description: 'Country',
    defaultMessage: 'Country',
  },
  name: {
    id: 'locations.name',
    description: 'Name',
    defaultMessage: 'Name',
  },
  parentLocation: {
    id: 'locations.parentLocation',
    description: 'Parent Location',
    defaultMessage: 'Parent Location',
  },
  customerLabel: {
    id: 'locations.customerLabel',
    description: 'Customer Label',
    defaultMessage: 'Customer',
  },
  customerOptionalLabel: {
    id: 'locations.customerOptionalLabel',
    description: 'Customer Optional Label',
    defaultMessage: 'Select if this is a customer location',
  },
  locationType: {
    id: 'locations.locationType',
    description: 'Location Type',
    defaultMessage: 'Location Type',
  },
  address: {
    id: 'locations.address',
    description: 'Address ',
    defaultMessage: 'Address ',
  },
  address1: {
    id: 'locations.address1',
    description: 'Address 1',
    defaultMessage: 'Address 1',
  },
  address2: {
    id: 'locations.address2',
    description: 'Address 2',
    defaultMessage: 'Address 2',
  },
  address3: {
    id: 'locations.address3',
    description: 'Address 3',
    defaultMessage: 'Address 3',
  },
  city: {
    id: 'locations.city',
    description: 'City',
    defaultMessage: 'City',
  },
  state: {
    id: 'locations.state',
    description: 'State',
    defaultMessage: 'State',
  },
  postCode: {
    id: 'locations.postCode',
    description: 'Postal Code',
    defaultMessage: 'Postal Code',
  },
  lat: {
    id: 'locations.lat',
    description: 'Latitude',
    defaultMessage: 'Latitude',
  },
  lng: {
    id: 'locations.lng',
    description: 'Longitude',
    defaultMessage: 'Longitude',
  },
  create: {
    id: 'locations.create',
    description: 'Create button',
    defaultMessage: 'Create',
  },
  update: {
    id: 'locations.update',
    description: 'Update',
    defaultMessage: 'Update',
  },
  cancel: {
    id: 'locations.cancel',
    description: 'Cancel button label',
    defaultMessage: 'Cancel',
  },
  delete: {
    id: 'locations.delete',
    description: 'Delete button label',
    defaultMessage: 'Delete',
  },
  countryValidation: {
    id: 'locations.countryValidation',
    description: 'Country is required',
    defaultMessage: 'Country is required',
  },
  nameValidation: {
    id: 'locations.nameValidation',
    description: 'Name is required',
    defaultMessage: 'Name is required',
  },
  address1Validation: {
    id: 'locations.address1Validation',
    description: 'Address is required',
    defaultMessage: 'Address is required',
  },
  cityValidation: {
    id: 'locations.cityValidation',
    description: 'City is required',
    defaultMessage: 'City is required',
  },
  stateValidation: {
    id: 'locations.stateValidation',
    description: 'State is required',
    defaultMessage: 'State is required',
  },
  postCodeValidation: {
    id: 'locations.postCodeValidation',
    description: 'Postal Code is required',
    defaultMessage: 'Postal Code is required',
  },
  createLocationTitle: {
    id: 'locations.createLocationTitle',
    description: 'Create Location Modal title',
    defaultMessage: 'Create {locationType}',
  },
  viewButtonLbl: {
    id: 'locations.viewButtonLbl',
    description: 'View link label',
    defaultMessage: 'View',
  },
  editButtonLbl: {
    id: 'locations.editButtonLbl',
    description: 'Edit link label',
    defaultMessage: 'Edit',
  },
  customerSelectable: {
    id: 'locations.customerSelectable',
    description: 'Customer Selectable',
    defaultMessage: 'Customer Selectable',
  },
  clearSelection: {
    id: 'locations.clearSelection',
    description: 'Clear Selection',
    defaultMessage: 'Clear Selection',
  },
  standardLocations: {
    id: 'locations.tabs.standardLocations',
    description: 'Standard Locations',
    defaultMessage: 'Standard Locations',
  },
  newStandardLocation: {
    id: 'locations.tabs.newStandardLocation',
    description: 'New Standard Location',
    defaultMessage: 'New Standard Location',
  },
  airports: {
    id: 'locations.tabs.airports',
    description: 'Airports',
    defaultMessage: 'Airports',
  },
  airport: {
    id: 'locations.tabs.airport',
    description: 'Airport',
    defaultMessage: 'Airport',
  },
  railwayStations: {
    id: 'locations.tabs.railwayStations',
    description: 'Railway Stations',
    defaultMessage: 'Railway Stations',
  },
  railwayStation: {
    id: 'locations.tabs.railwayStation',
    description: 'Railway Station',
    defaultMessage: 'Railway Station',
  },
  fuelStations: {
    id: 'locations.tabs.fuelStations',
    description: 'Fuel Stations',
    defaultMessage: 'Fuel Stations',
  },
  fuelStation: {
    id: 'locations.tabs.newFuelStation',
    description: 'Fuel Station',
    defaultMessage: 'Fuel Station',
  },
  terminals: {
    id: 'locations.tabs.terminals',
    description: 'Terminals',
    defaultMessage: 'Terminals',
  },
  terminal: {
    id: 'locations.tabs.terminal',
    description: 'Terminal',
    defaultMessage: 'Terminal',
  },
  defaultTransportModeValidation: {
    id: 'locations.defaultTransportModeValidation',
    description: 'Default Transport Mode is required',
    defaultMessage: 'Transport Mode is required',
  },
  defaultCurrency: {
    id: 'locations.defaultCurrency',
    description: 'Default Currency',
    defaultMessage: 'Default Currency',
  },
  latValidation: {
    id: 'locations.latValidation',
    description: 'Latitude is required',
    defaultMessage: 'Latitude is required',
  },
  lngValidation: {
    id: 'locations.lngValidation',
    description: 'Longitude is required',
    defaultMessage: 'Longitude is required',
  },
  latRangeValidation: {
    id: 'locations.latRangeValidation',
    description: 'Latitude must be between -90 and 90 degrees',
    defaultMessage: 'Latitude must be between -90.0° and +90.0°',
  },
  lngRangeValidation: {
    id: 'locations.lngRangeValidation',
    description: 'Longitude must be between -180 and 180 degrees',
    defaultMessage: 'Longitude must be between -180.0° and +180.0°',
  },
  latFormatValidation: {
    id: 'locations.latFormatValidation',
    description: 'Latitude must be a valid number',
    defaultMessage: 'Latitude must be a valid number',
  },
  lngFormatValidation: {
    id: 'locations.lngFormatValidation',
    description: 'Longitude must be a valid number',
    defaultMessage: 'Longitude must be a valid number',
  },
  seaports: {
    id: 'locations.tabs.seaports',
    description: 'Seaports',
    defaultMessage: 'Seaports',
  },
  seaport: {
    id: 'locations.tabs.seaport',
    description: 'Seaport',
    defaultMessage: 'Seaport',
  },
  shipper: {
    id: 'locations.tabs.shipper',
    description: 'Shipper',
    defaultMessage: 'Shipper',
  },
  customerValidation: {
    id: 'locations.customerValidation',
    description: 'Customer is required',
    defaultMessage: 'Customer is required',
  },
  systemDefined: {
    id: 'locations.systemDefined',
    description: 'System Defined',
    defaultMessage: 'System Defined',
  },
  enabled: {
    id: 'locations.enabled',
    description: 'Enabled',
    defaultMessage: 'Enabled',
  },
  createNewShipper: {
    id: 'locations.createNewShipper',
    description: 'Create New Shipper button',
    defaultMessage: 'New Shipper',
  },
  createNewFuelStation: {
    id: 'locations.createNewFuelStation',
    description: 'Create New Fuel Station button',
    defaultMessage: 'New Fuel Station',
  },
  createNewTerminal: {
    id: 'locations.createNewTerminal',
    description: 'Create New Terminal',
    defaultMessage: 'New Terminal',
  },
  createNewAirport: {
    id: 'locations.createNewAirport',
    description: 'Create New Airport',
    defaultMessage: 'New Airport',
  },
  createNewSeaport: {
    id: 'locations.createNewSeaport',
    description: 'Create New Seaport location button',
    defaultMessage: 'New Seaport',
  },
  standard: {
    id: 'locations.standard',
    description: 'Standard location button',
    defaultMessage: 'Standard Location',
  },
  newLocationTitle: {
    id: 'locations.newLocationTitle',
    description: 'New Location',
    defaultMessage: 'New {locationType}',
  },
  editLocationTitle: {
    id: 'locations.editLocationTitle',
    description: 'Edit Location',
    defaultMessage: 'Edit {locationType}',
  },
  viewLocationTitle: {
    id: 'locations.viewLocationTitle',
    description: 'View Location',
    defaultMessage: 'View {locationType}',
  },
  locationCreated: {
    id: 'locations.locationCreated',
    description: 'New Location created',
    defaultMessage: 'New Location created',
  },
  shipperCreated: {
    id: 'locations.shipperCreated',
    description: 'New Shipper created',
    defaultMessage: 'New Shipper created',
  },
  airportCreated: {
    id: 'locations.airportCreated',
    description: 'New Airport created',
    defaultMessage: 'New Airport created',
  },
  seaportCreated: {
    id: 'locations.seaportCreated',
    description: 'New Seaport created',
    defaultMessage: 'New Seaport created',
  },
  terminalCreated: {
    id: 'locations.terminalCreated',
    description: 'New Terminal created',
    defaultMessage: 'New Terminal created',
  },
  fuelStationCreated: {
    id: 'locations.fuelStationCreated',
    description: 'New Fuel Station created',
    defaultMessage: 'New Fuel Station created',
  },
  standardLocationCreated: {
    id: 'locations.standardLocationCreated',
    description: 'New Standard Location created',
    defaultMessage: 'New Standard Location created',
  },
  locationUpdated: {
    id: 'locations.locationUpdated',
    description: 'Location updated',
    defaultMessage: 'Location details updated',
  },
  shipperUpdated: {
    id: 'locations.shipperUpdated',
    description: 'Shipper updated',
    defaultMessage: 'Shipper details updated',
  },
  airportUpdated: {
    id: 'locations.airportUpdated',
    description: 'Airport updated',
    defaultMessage: 'Airport details updated',
  },
  seaportUpdated: {
    id: 'locations.seaportUpdated',
    description: 'Seaport updated',
    defaultMessage: 'Seaport details updated',
  },
  terminalUpdated: {
    id: 'locations.terminalUpdated',
    description: 'Terminal updated',
    defaultMessage: 'Terminal details updated',
  },
  fuelStationUpdated: {
    id: 'locations.fuelStationUpdated',
    description: 'Fuel Station updated',
    defaultMessage: 'Fuel Station details updated',
  },
  standardLocationUpdated: {
    id: 'locations.standardLocationUpdated',
    description: 'Standard Location updated',
    defaultMessage: 'Standard Location details updated',
  },
  locationDeleted: {
    id: 'locations.locationDeleted',
    description: 'Location deleted',
    defaultMessage: 'Location deleted',
  },
  shipperDeleted: {
    id: 'locations.shipperDeleted',
    description: 'Shipper deleted',
    defaultMessage: 'Shipper deleted',
  },
  airportDeleted: {
    id: 'locations.airportDeleted',
    description: 'Airport deleted',
    defaultMessage: 'Airport deleted',
  },
  seaportDeleted: {
    id: 'locations.seaportDeleted',
    description: 'Seaport deleted',
    defaultMessage: 'Seaport deleted',
  },
  terminalDeleted: {
    id: 'locations.terminalDeleted',
    description: 'Terminal deleted',
    defaultMessage: 'Terminal deleted',
  },
  fuelStationDeleted: {
    id: 'locations.fuelStationDeleted',
    description: 'Fuel Station deleted',
    defaultMessage: 'Fuel Station deleted',
  },
  standardLocationDeleted: {
    id: 'locations.standardLocationDeleted',
    description: 'Standard Location deleted',
    defaultMessage: 'Standard Location deleted',
  },
  locationDeleteError: {
    id: 'locations.locationDeleteError',
    description: 'Error deleting location',
    defaultMessage: 'Failed to delete location',
  },
  locationCreateError: {
    id: 'locations.locationCreateError',
    description: 'Error creating location',
    defaultMessage: 'Failed to create location',
  },
  locationUpdateError: {
    id: 'locations.locationUpdateError',
    description: 'Error updating location',
    defaultMessage: 'Failed to update location details',
  },
})

export default messages
